module.exports = __webpack_public_path__ + "std/img/flags.723494a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/ekicon/flags.png
// module id = bzyl
// module chunks = 17